// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

export class Binding {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):Binding {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsBinding(bb:flatbuffers.ByteBuffer, obj?:Binding):Binding {
  return (obj || new Binding()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsBinding(bb:flatbuffers.ByteBuffer, obj?:Binding):Binding {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new Binding()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

nodeIndex():number {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
}

kind():string|null
kind(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
kind(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

key():string|null
key(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
key(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

target():string|null
target(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
target(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

static startBinding(builder:flatbuffers.Builder) {
  builder.startObject(4);
}

static addNodeIndex(builder:flatbuffers.Builder, nodeIndex:number) {
  builder.addFieldInt32(0, nodeIndex, 0);
}

static addKind(builder:flatbuffers.Builder, kindOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, kindOffset, 0);
}

static addKey(builder:flatbuffers.Builder, keyOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, keyOffset, 0);
}

static addTarget(builder:flatbuffers.Builder, targetOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, targetOffset, 0);
}

static endBinding(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createBinding(builder:flatbuffers.Builder, nodeIndex:number, kindOffset:flatbuffers.Offset, keyOffset:flatbuffers.Offset, targetOffset:flatbuffers.Offset):flatbuffers.Offset {
  Binding.startBinding(builder);
  Binding.addNodeIndex(builder, nodeIndex);
  Binding.addKind(builder, kindOffset);
  Binding.addKey(builder, keyOffset);
  Binding.addTarget(builder, targetOffset);
  return Binding.endBinding(builder);
}
}
